import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
} from 'admin-on-rest'
import { YearMonthFilters } from './Filters'
import { Link } from 'react-router-dom'
import { stringify } from 'query-string'

const rowStyle = (record, index) => ({
	fontWeight: ! record.id ? 'bold' : 'normal',
	backgroundColor: ! record.id ? '#fafafa' : '',
});

const disabledViewButton = ({ num_proceeds_collected, num_di_collected }) => (
	! num_proceeds_collected && ! num_di_collected
)

const displayViewButton = ({ id, num_proceeds_collected, num_di_collected }) => {
	if ( ! id ) {
		return { display: 'none' }
	}
	if ( ! num_proceeds_collected && ! num_di_collected ) {
		return { display: 'none' }
	}
}

const NumAccountsCollectedLink = ( props ) => {
	const getURLParam = (name) => (window.location.search.split(name + '=')[1] || '').split('&')[0]
	const dateParam = JSON.parse( decodeURIComponent( getURLParam( 'filter' ) ) )
	const { record, filterDateBy } = props

	const filter = {
		year: dateParam.year,
		month: dateParam.month,
		filter_date_by: filterDateBy,
		dealership: record.id,
	}

	if ( record[ props.source ] && record.id ) {
		return (
			<Link to={{
				pathname: '/report_collections_accounts',
				search: stringify({ page: 1, perPage: 25, filter: JSON.stringify( filter ) }),
			}}>
				<NumberField { ...props } />
				</Link>
		)
	} else {
		return <NumberField { ...props } />
	}
}

export const CollectionsDealership = (props) => (
    <List {...props}
		title="Collections Overview by Dealership"
		filters={<YearMonthFilters />}
		actions={<ListActions refreshInterval="900000" />}
		sort={{ field: 'dealership_label', order: 'ASC' }}
		perPage={100}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid rowStyle={rowStyle}>
					<TextField source="dealership_label" label="Dealership" />
					<NumAccountsCollectedLink source="num_proceeds_collected" label="# Proc Collected" filterDateBy="proceeds_collection" />
					<NumberField source="total_proceeds_collected" label="Proc Collected" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
					<NumberField source="discrepancy_proceeds" label="Discrepancy Proceeds" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} style={{ borderRight: '1px solid #ddd' }} />
					<NumAccountsCollectedLink source="num_di_collected" label="# DI Collected" filterDateBy="di_collection" />
					<NumberField source="total_di_collected" label="DI Collected" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
					<NumberField source="discrepancy_di" label="Discrepancy DI" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/CollectionsDealership.js